/**
 * Contexte d’authentification — isolé du composant pour que le rafraîchissement
 * à chaud de Vite ne recrée pas le contexte à chaque édition du provider.
 */

import { createContext } from 'react'

import type { Session } from './types'

export interface ValeurAuth {
  /** `null` = personne n’est connecté (ce n’est pas une erreur). */
  readonly session: Session | null
  /** Première résolution de la session en cours : on n’affiche encore rien. */
  readonly chargement: boolean
  /** Connexion staff (email + mot de passe argon2id côté serveur). */
  readonly connecterStaff: (email: string, motDePasse: string) => Promise<Session>
  /** Demande d’un lien magique (réponse volontairement neutre — POR-01). */
  readonly demanderLienMagique: (email: string) => Promise<void>
  /** Vérification du jeton reçu par email (usage unique, 15 min). */
  readonly verifierLienMagique: (jeton: string) => Promise<Session>
  readonly deconnecter: () => Promise<void>
  /** Force une relecture de `GET /auth/moi`. */
  readonly rafraichir: () => Promise<void>
}

export const ContexteAuth = createContext<ValeurAuth | null>(null)
